module.exports = __webpack_public_path__ + "media/checkmarks/white-tick-502ce326.svg";